import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

const guideIcons = ["ri-layout-grid-line", "ri-scales-3-line", "ri-search-eye-line", "ri-external-link-line"];

export default function About() {
  const { t } = useTranslation();

  const steps = [
    { title: t("guide.step1.title"), desc: t("guide.step1.desc") },
    { title: t("guide.step2.title"), desc: t("guide.step2.desc") },
    { title: t("guide.step3.title"), desc: t("guide.step3.desc") },
    { title: t("guide.step4.title"), desc: t("guide.step4.desc") },
  ];

  return (
    <>
      <section className="bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <Reveal>
            <div>
              <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl leading-tight">
                {t("about.title")}
              </h2>
              <p className="text-foreground-700 mt-6 leading-relaxed">{t("about.p1")}</p>
              <p className="text-foreground-700 mt-4 leading-relaxed">{t("about.p2")}</p>
              <p className="text-foreground-700 mt-4 leading-relaxed">{t("about.p3")}</p>

              <Link
                to="/usfans-spreadsheet-guide"
                className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-md bg-secondary-500 text-background-50 font-semibold text-sm hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {t("about.cta")}
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20minimalist%20flat%20lay%20of%20a%20laptop%20tablet%20and%20open%20notebook%20displaying%20an%20organized%20product%20spreadsheet%20on%20a%20soft%20warm%20off%20white%20desk%20soft%20diffused%20natural%20lighting%20editorial%20productivity%20photography%20high%20detail%20fresh%20airy%20mood&width=900&height=700&seq=about-spreadsheet-01&orientation=landscape"
                alt="USFans Spreadsheet product discovery"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <Reveal>
          <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl text-center">
            {t("guide.title")}
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
          {steps.map((s, i) => (
            <Reveal key={s.title} delay={i * 80}>
              <div className="h-full rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
                <div className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center mb-4">
                  <i className={`${guideIcons[i]} text-xl`}></i>
                </div>
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs font-bold text-accent-600">{i + 1}</span>
                  <h3 className="font-heading font-semibold text-foreground-900 text-base">
                    {s.title}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}